import { render, staticRenderFns } from "./pendingDetail.vue?vue&type=template&id=c0695b04&scoped=true&"
import script from "./pendingDetail.vue?vue&type=script&lang=tsx&"
export * from "./pendingDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./pendingDetail.vue?vue&type=style&index=0&id=c0695b04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0695b04",
  null
  
)

export default component.exports